import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { BfModal, BfDialog, BfButton, BfSpinner } from 'components/Butterfly';
import { FETCH_SITES } from 'src/store/types';
import Site from 'src/api/site';
import TopBar from './TopBar';
import Project from 'src/api/project';
export default Vue.extend({
    components: { TopBar, BfModal, BfDialog, BfButton, BfSpinner },
    props: {
        verification: { type: Boolean, default: false },
        badDomain: { type: String, default: '' },
        membershipDisabled: { type: String, default: '' },
    },
    data() {
        return {
            siteToDelete: null,
            showDeleteModal: false,
            loading: true,
            checkedRedirect: false,
        };
    },
    computed: {
        ...mapGetters([
            'availableSites', 'userName', 'currentUser',
        ]),
    },
    watch: {
        availableSites(v) {
            if (v.length > 0) {
                this.checkRedirect();
            }
            else if (v !== undefined) {
                this.loading = false;
            }
        },
    },
    metaInfo() {
        return {
            title: 'Sites - Kapiche'
        };
    },
    methods: {
        ...mapActions({
            FETCH_SITES,
        }),
        async checkRedirect() {
            if (this.loading && !this.checkedRedirect) {
                this.checkedRedirect = true;
                // Check whether a newly signed up viewer user should be
                // redirected straight to their dashboard. The user must
                // be on the /verified route after verifying their email.
                // User has access to 1 site as a viewer
                if (this.verification &&
                    this.availableSites?.length === 1 &&
                    this.availableSites?.[0].disabled == false &&
                    this.availableSites?.[0].user_type === 'VIEWER') {
                    const [site] = this.availableSites;
                    const { data } = await Project.getAllDashboardsForSite(site.domain);
                    // User has access to 1 dashboard as a viewer
                    if (data.length === 1) {
                        const dashboardURL = `/${site.domain}/dashboards/${data[0].url_code}`;
                        this.$router.push(dashboardURL);
                    }
                    else {
                        this.loading = false;
                    }
                    // We don't want to force the user to click on their site if there's
                    // only one option. We know which site, so go straight there.
                }
                else if (this.availableSites?.length === 1 &&
                    this.availableSites?.[0].disabled == false) {
                    const [site] = this.availableSites;
                    this.$router.push({ name: 'home', params: { site: site.domain } });
                }
                else {
                    this.loading = false;
                }
            }
        },
        createSite() {
            this.$router.push({ name: 'create-site-form' });
        },
        deleteSiteModal(site) {
            this.siteToDelete = site;
            this.showDeleteModal = true;
        },
        closeDeleteModal() {
            this.showDeleteModal = false;
            this.siteToDelete = null;
        },
        async deleteSite(site) {
            this.closeDeleteModal();
            await Site.deleteSite(site.domain);
            this.FETCH_SITES();
        }
    }
});
